<div class="page-content">
  <div class="user-info-page-head">
    <h1 class="user-info-page-head__title">User information</h1>
    <p class="user-info-page-head__client">{{ clientName }} · {{ clientCode }}</p>
  </div>
  <div class="subtext">
    Members under this client. Use search and pagination to work through large lists.
  </div>

  <p class="back-to-clients">
    <button type="button" class="back-to-clients__btn" (click)="backToClients()">← Back to clients</button>
  </p>

  <section class="clients-card">
    <div class="clients-card__search">
      <div class="clients-card__search-row">
        <label class="client-search">
          <span class="client-search__icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Zm0-2a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
                fill="#98A2B3" />
              <path d="m16.5 16.5 4.2 4.2" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" />
            </svg>
          </span>
          <input
            type="search"
            class="client-search__input"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
            placeholder="Search by email, role, or date…"
            autocomplete="off"
            aria-label="Search users" />
        </label>
        <button type="button" class="button add-toolbar__btn" (click)="openAddDialog()">Add User</button>
      </div>
    </div>

    <div class="action-banner" *ngIf="actionMessage">{{ actionMessage }}</div>

    <div class="table-state" *ngIf="loading">Loading users...</div>
    <div class="table-state table-state--error" *ngIf="!loading && loadError">{{ loadError }}</div>

    <div class="users-table-scroll" *ngIf="!loading && !loadError && visibleUsers.length">
      <table class="clients-table clients-table--users">
        <thead>
          <tr>
            <th scope="col">Email</th>
            <th scope="col">Role</th>
            <th scope="col">Added</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of pagedUsers">
            <td>{{ u.email }}</td>
            <td>{{ u.role }}</td>
            <td>{{ u.createdAt | date: 'short' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-state" *ngIf="!loading && !loadError && emptyHint">
      {{ emptyHint }}
    </div>

    <div class="table-pagination" *ngIf="!loading && !loadError && visibleUsers.length">
      <span class="table-pagination__info">{{ pageRangeStart }}–{{ pageRangeEnd }} of {{ visibleUsers.length }}</span>
      <div class="table-pagination__controls">
        <label class="table-pagination__size">
          Rows
          <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
            <option *ngFor="let n of pageSizeOptions" [ngValue]="n">{{ n }}</option>
          </select>
        </label>
        <button type="button" class="inline-button" [disabled]="pageIndex === 0" (click)="prevPage()">Previous</button>
        <span class="table-pagination__page">{{ pageIndex + 1 }} / {{ totalPages }}</span>
        <button type="button" class="inline-button" [disabled]="pageIndex >= totalPages - 1" (click)="nextPage()">
          Next
        </button>
      </div>
    </div>
  </section>
</div>

<div class="modal-overlay" *ngIf="addDialogOpen" (click)="closeAddDialog()">
  <div class="modal-box modal-box--user-add" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Add user</h3>
      <button type="button" class="modal-close" aria-label="Close" (click)="closeAddDialog()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="users-preview-add users-preview-add--dialog">
        <label class="form-group">
          <span class="form-label">User email</span>
          <input
            type="email"
            class="form-input"
            [(ngModel)]="addEmail"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Enter user email"
            autocomplete="off" />
        </label>
        <label class="form-group users-preview-password">
          <span class="form-label">Password</span>
          <div class="users-preview-password__wrap">
            <input
              [type]="passwordVisible ? 'text' : 'password'"
              class="form-input users-preview-password__input"
              [(ngModel)]="addPassword"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Min. 6 characters"
              autocomplete="new-password" />
            <button
              type="button"
              class="users-preview-password__toggle"
              (click)="togglePasswordVisible()"
              [attr.aria-pressed]="passwordVisible"
              [attr.aria-label]="passwordVisible ? 'Hide password' : 'Show password'">
              <svg
                *ngIf="!passwordVisible"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                width="20"
                height="20"
                aria-hidden="true">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <svg
                *ngIf="passwordVisible"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                width="20"
                height="20"
                aria-hidden="true">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
              </svg>
            </button>
          </div>
        </label>
        <p class="message message--error" *ngIf="addError">{{ addError }}</p>
      </div>
    </div>
    <div class="modal-actions">
      <button type="button" class="button button-transparent" [disabled]="addingUser" (click)="closeAddDialog()">
        Cancel
      </button>
      <button type="button" class="button" [disabled]="addingUser" (click)="submitAddUser()">
        {{ addingUser ? 'Saving…' : 'Save' }}
      </button>
    </div>
  </div>
</div>
